import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]理财商城弹框-热销基金查询
 */
export function getHotSellFundUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultLcHotSellDto> {
  return resource.postNoAuth('/lcPop/getHotSellFund', req, config);
}
